import React, { useState, useEffect } from "react";
import "./Home.css";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import WorldMapSection from "../pages/WorldMapSection";
import useAnimateOnView from "../pages/useAnimateOnView";


import PM from "../assets/images/new image PM3.png";
import Minister from "../assets/images/shiva1w.avif"
import { text } from "@fortawesome/fontawesome-svg-core";

const images = [
  "/images/foxtail-home1.avif",
  "/images/Sorghum.jpg",
  "/images/Little-home.avif",
  "/images/foxtail-home1.avif",
  "/images/pearl-home.jpg",
];

const announcements = [
  {
    text: "Inviting Countries and Organisations to Join MAHARISHI ",
    link: "/maharishiinvite",
    isNew: true
  },
  {
    text: "Millets and Ancient Grains International Conference (MAGIC)  Postponed - Revised Dates will be Announced Soon",
    link: "/magic",
    isNew: true
  },
  // {
  //   text: "Last Date for Abstract Submission for MAGIC 2026 is 30th July 2024",
  //   link: "/magic2026_registration",
  //   isNew: true
  // }
  
];



const Home = () => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const [currentAnnouncementIndex, setCurrentAnnouncementIndex] = useState(0);
    const { ref: leaderRef, visible: leaderVisible } = useAnimateOnView(0.5);
    const { ref: highlightsRef, visible: highlightsVisible } = useAnimateOnView(0.5);



  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrentSlideIndex((prev) => (prev + 1) % images.length);
    }, 3000);

    const announcementInterval = setInterval(() => {
      setCurrentAnnouncementIndex((prev) => (prev + 1) % announcements.length);
    }, 3000);

    AOS.init({ duration: 1000 });

    return () => {
      clearInterval(slideInterval);
      clearInterval(announcementInterval);
    };
  }, []);

  const [activeIndex, setActiveIndex] = useState(0);

const faqs = [
  {
    question: "1. What is MAHARISHI?",
    answer: (
      <>
        <p>
          MAHARISHI has been conceptualized as a global response to emerging challenges in agriculture, nutrition, and climate resilience, as highlighted during the G20 Meeting of Agricultural Chief Scientists (MACS) held in Varanasi in 2023.
        </p>
        <p>
          It addresses fragmented research on millets and ancient grains by creating a coordinated international platform for countries and institutions to strengthen collaboration, innovation, and knowledge sharing.
        </p>
        <p>
          The initiative supports sustainable food systems, enhanced nutrition security, and climate-resilient agriculture worldwide.
        </p>
      </>
    )
  },

  {
    question: "2. Who can join MAHARISHI?",
    answer: (
      <>
        <p>
          Membership in MAHARISHI is open to a wide range of stakeholders engaged in research, policy, and development related to millets and ancient grains.
        </p>
        <p>
          Eligible participants include Member Countries, international research centres, public research institutions, universities, private sector entities, as well as civil society organizations and farmer associations.
        </p>
        <p>
          Each participating country is represented by one official institution. Membership is voluntary and based on shared commitment to advancing global research collaboration.
        </p>
      </>
    )
  },

  {
    question: "3. What are the membership categories and Fee?",
    answer: (
      <>
        <p><strong>MAHARISHI comprises two broad categories of membership:</strong></p>

        <p><strong>a) Institutional Members:</strong></p>
        <p>This includes G20 Member States, international agricultural research centres, and institutions from non-G20 countries.</p>
        <ul>
          <li>1) G20 Member States / Institutions: USD 25,000 per annum</li>
          <li>2) International Research Centres: USD 25,000 per annum</li>
          <li>3) Non-G20 Institutions: USD 5,000 per annum</li>
        </ul>

        <p><strong>b) Private Members:</strong></p>
        <p>This includes multinational companies, national companies within member countries, and small or start-up enterprises.</p>
        <ul>
          <li>1) Multinational Companies: USD 50,000 per annum</li>
          <li>2) National Companies: USD 25,000 per annum</li>
          <li>3) Small & Start-up Companies: USD 10,000 per annum</li>
        </ul>

        <p>
          Members are required to contribute an annual membership fee based on their category. In certain cases, in-kind contributions such as technical expertise, infrastructure, or research inputs may be considered in lieu of fees, subject to approval
        </p>
      </>
    )
  },

  {
    question: "4. How to apply for membership (step-by-step)?",
    answer: (<>
    <p>The process for joining MAHARISHI is structured and collaborative:</p>
      <ol>
        <li><strong>a.	Expression of Interest:</strong> The interested country or organization communicates its intent to join MAHARISHI.</li>
        <li><strong>b.	Invitation/Engagement:</strong> Membership is generally extended through invitation or formal engagement with the MAHARISHI Secretariat.</li>
        <li><strong>c.	Submission of Application:</strong> The applicant submits the prescribed membership form along with relevant institutional details.</li>
        <li><strong>d.	Review and Approval:</strong> The application is reviewed by the appropriate governing bodies, and approval is granted based on alignment with the objectives of MAHARISHI.</li>
        <li><strong>e.	Confirmation and Contribution:</strong> Upon approval, membership is confirmed and the applicable annual contribution is made.</li>
        <li><strong>f.	Onboarding:</strong> The member is onboarded into MAHARISHI platforms, committees, and collaborative activities.</li>
      </ol>
    </>)
  },

  {
    question: "5. What are the benefits of joining MAHARISHI?",
    answer: (<>
    <p>Membership in MAHARISHI provides several strategic and operational benefits:</p>
      <ul>
        <li><strong>a. Global Collaboration:</strong> Access to a high-level international platform and participation in global conferences and policy dialogues.</li>
        <li><strong>b. Research & Innovation:</strong> Opportunity to shape research priorities and access emerging scientific knowledge and innovations.</li>
        <li><strong>c. Networking and Partnerships:</strong> Engagement with governments, research institutions, CGIAR centres, academia, and industry stakeholders.</li>
        <li><strong>d. Funding Opportunities:</strong> Access to coordinated national and international research funding and participation in multi-country projects.</li>
        <li><strong>e. Capacity Building:</strong> Opportunities for training, workshops, knowledge exchange, and recognition through awards for young scientists.</li>
        <li><strong>f. Policy Support and Strategic Influence:</strong> Contribution to global discussions on food security, climate resilience, and sustainable agriculture.</li>
        <li><strong>g. Access to Expertise:</strong> Participation in governance structures such as the Governing Board, Research Advisory Group, and Expert Working Groups.</li>
      </ul>
      <p>These benefits enable members to strengthen their national initiatives while contributing to global efforts in ensuring food and nutrition security and promoting sustainable agricultural systems.</p>
    </>)
  },

  {
    question: "6. What are the upcoming Events?",
    answer: (
      <p>
        MAGIC-2026 (Millets & Ancient Grains International Conference) is the flagship event of MAHARISHI and will be held soon. The conference will bring together global experts, researchers, policymakers, and industry stakeholders to advance collaboration and innovation in millets and ancient grains. Further details and updates will be announced shortly - stay tuned.
      </p>
    )
  },

  {
    question: "7. How can I become an Expert Working Group Member?",
    answer: (
      <>
        <p>
         Expert Working Group (EWG) members are selected based on their expertise and relevance to the thematic areas of millets and ancient grains.
        </p>
        <p>
        Interested individuals may express their interest through their respective institution or member organization. Members can also be nominated by MAHARISHI member institutions, the Research Advisory Group, or the Steering Committee.
        </p>
        <p>
          EWGs are constituted for specific thematic areas, and experts are invited based on the requirements of the group. Selection is based on domain knowledge, experience, and the ability to contribute to the objectives of MAHARISHI.
        </p>
      </>
    )
  }
];


  return (
    <div className="home-container">
{/* Latest Announcements */}
           <section className="bg-gray-100 py-2 md:py-4 lg:py-6">
             <div className="flex items-center w-full px-4">
               <div className="w-full overflow-hidden relative">
<div className="inline-flex animate-ticker whitespace-nowrap px-4">      
               {announcements.map((item, index) => (
  <a
    key={index}
    href={item.link}
    target="_blank"
    rel="noopener noreferrer"
    className="announcement-item text-xs sm:text-sm md:text-base lg:text-lg text-gray-800 font-medium hover:text-blue-600 transition-colors duration-200"
  >
    {/* ✅ ADD THIS CONDITION */}
    {item.isNew && (
      <img
        src="https://media.tenor.com/UBNApyolWz4AAAAi/new-blinking-new-blinking-without-background.gif"
        alt="new"
        className="new-gif"
      />
    )}

    <span className="mx-2 sm:mx-3 md:mx-4 text-gray-500">|</span>

    {item.text}

    <span className="mx-2 sm:mx-3 md:mx-4 text-gray-500">|</span>
  </a>
))}
                 </div>
               </div>
             </div>
           </section>
      
       {/* Image Slider */}
       <div className="relative w-full h-[60vh] md:h-[90vh] overflow-hidden">
          {/* Images */}
          {images.map((src, index) => (
             <img
               key={index}
               src={src}
               alt={`slide-${index}`}
               className={`absolute top-0 left-0 w-full h-full object-cover transition-opacity duration-700 ${
                 index === currentSlideIndex ? "opacity-100" : "opacity-0"
               }`}
             />
             ))}
          
            {/* Full image overlay */}
               <div className="absolute inset-0 bg-black/10 z-10 pointer-events-none"></div>
                 <div className="hero-content">
  <div className="hero-left">
    <h2 className="maharishi-title">MAHARISHI</h2>
    <p className="maharishi-subtitle">
      Cultivating Heritage, Harnessing Innovations <br />
      For People and Planet
    </p>
    <a href="/contact" className="btn-outline">Join Us</a>

    {/* MAGIC Postponement Notice Card */}
<div className="hero-notice-card">
  <h4 className="hero-notice-title">
    MAGIC Update
    <img
      src="https://media.tenor.com/UBNApyolWz4AAAAi/new-blinking-new-blinking-without-background.gif"
      alt="new"
      className="new-gif hero-notice-gif"
    />
  </h4>
  <p>
    MAGIC (Millets and Ancient Grains International Conference) under MAHARISHI has been postponed. Revised dates will be announced soon.
  </p>
</div>
  </div>

  {/* RIGHT SIDE CARD */}
  <div className="hero-side-card">
    <h4>Objectives</h4>
    <div className="objectives-scroll">
<ul>
  <li>➤Connect researchers and institutions working on grain crops to share knowledge, identify research gaps, and strengthen collaboration.</li>
  <li>➤ Web platforms to connect researchers for seamless data exchange and collaboration 
Enable open and accessible sharing of communication materials and research insights.</li>
  <li>➤ Organize knowledge transfer, capacity building programs, and international workshops to support collaborative research 
Encourage researchers to actively engage in advancing work on millets and ancient grains.</li>
  <li>➤ Provide research and innovation prizes and/or awards to scientists to support and
promote their research interests.</li>
  
</ul>
</div>
  </div>
</div>
              </div>

      {/* Objectives — mobile only, appears below hero */}
      <div className="mobile-objectives">
        <h4>Objectives</h4>
        <div className="mobile-objectives-scroll">
        <ul>
          <li>➤ Connect researchers and institutions working on grain crops to share knowledge, identify research gaps, and strengthen collaboration.</li>
          <li>➤ Web platforms to connect researchers for seamless data exchange and collaboration. Enable open and accessible sharing of communication materials and research insights.</li>
          <li>➤ Organize knowledge transfer, capacity building programs, and international workshops to support collaborative research. Encourage researchers to actively engage in advancing work on millets and ancient grains.</li>
          <li>➤ Provide research and innovation prizes and/or awards to scientists to support and promote their research interests.</li>
        </ul>
        </div>
      </div>
      {/* Leader Messages */}
       <section
         ref={leaderRef}
         className={`section-container ${leaderVisible ? "animate" : ""}`}
       >
        {[ {
          img: PM,
          quote: "'Shree Anna' has been a part of the lifestyle in India for centuries. In different regions of the country, many types of coarse grains like Jowar, Bajra, Ragi, Sama, Kangni, Cheena, Kodon, Kutki, Kuttu are prevalent. We want to share our agricultural practices and experiences related to 'Shree Anna' with the world. We also want to learn anything new and special that the world and other countries have to offer. We also intend to learn.",
          author: "- Shri Narendra Modi",
          position: "Hon’ble Prime Minister of India",
        },
        {
          img: Minister,
          quote: "We must ensure food and nutritional security for our 1.44 billion population, preserve our soil for future generations, and contribute to global food availability. While many countries are pursuing material progress at the cost of nature, India must choose a path of sustainable development that protects nature",
          // link: "https://economictimes.indiatimes.com/news/india/millets-can-help-tackle-challenges-of-food-security-pm-modi/articleshow/98751033.cms?from=mdr",
          author: "- Shivraj Singh Chouhan",
          position: "Hon’ble Minister of Agriculture & Farmer's Welfare",
        }
        ].map((item, idx) => (
<           div className="card fade-up" key={idx}>
            <img src={item.img} alt={item.author} />
            <div className="card-content">
              {item.quote && <p>{item.quote}</p>}
              {item.link && <a href={item.link}>read more</a>}
              <p className="quote-author">{item.author}</p>
              <p className="quote-position">{item.position}</p>
            </div>
          </div>
        ))}
      </section>

      {/* Highlights Section */}
       <section
         id="latest-updates"
         ref={highlightsRef}
         className={`py-5 highlights-section ${highlightsVisible ? "animate" : ""}`}
       >

         <div className="container">
           <h2
             className="fs-4 text-start title-shift highlights-title"
               // title from LEFT
           >
             HIGHLIGHTS
           </h2>
       
           <div className="row">
             {[
               {
                 img: "images/employee.png",
                 title: "EXPERT WORKING GROUPS",
                 text:
                   "Working groups are established by bringing together experts with a focus on a topic of relevance with broader vision and specific objectives. It provides a platform for knowledge sharing on specific research and organizational development.",
               },
               {
                 img: "images/crop_image.png",
                 title: "AHEAD",
                 text:
                   "Conducting regular progress and coordination meetings to ensure the project stays on track and to address any challenges.Stakeholders meet, EWG meeting, formulation of consultative groups for implementation of MAHARISHI.",
               },
               {
                 img: "images/video_image.png",
                 title: "VIDEOS",
                 text:
                   "Our Expert Working Groups record presentations and webinars as well as they hold video competitions. All video recordings are available soon.",
               },
             ].map((item, idx) => (
               <div
                 className="col-md-4 mb-2 fade-left"
                 style={{ transitionDelay: `${idx * 200}ms` }}
                 key={idx}
               >

                 <div className="card h-100">
                   <img
                     src={item.img}
                     className="card-img-top1"
                     alt={`Update ${idx + 1}`}
                   />
                   <div className="card-body">
                     <h5 className="card-title fs-5 fw-bold custom-color">
                       {item.title}
                     </h5>
                     <p className="card-text">{item.text}</p>
                     {/* <a href="#" className="btn btn-primary py-2 px-4 fs-5">
                       Learn More
                     </a> */}
                   </div>
                 </div>
               </div>
             ))}
           </div>
         </div>
       </section>


      {/* World Map Section  */}
      <WorldMapSection />

      {/* Latest News Section */}
     <section id="latest-news" className="relative overflow-hidden text-white">
       {/* Background Video */}
       <video
       autoPlay
       muted
       loop
       className="bg-video"
     >
       <source src="images/millets_video2.mp4" type="video/mp4" />
     </video>



      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-white/10"></div>

      {/* Content */}
     <div className="relative z-10 w-full px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-20 text-center">
      
          {/* Left Column */}
          <div className="flex flex-col items-center h-full gap-0">
            <h2 className="text-3xl md:text-4xl font-bold text-[#FFFFFFF] mb-4">
              NEWSLETTER
            </h2>
            <p className="text-base md:text-lg max-w-md mb-6">
              Sign Up to explore the World of Traditional Grains through our
              Quarterly Newsletter. Click below to know more.
              Quarterly Newsletter. Click below to know more.
           </p>
            <a
              href="\newsletter"
              className="learn-more-btn mt-auto"
              >
              Learn More
            </a>

          </div>

          {/* Right Column */}
          <div className="flex flex-col items-center h-full gap-0">
            <h2 className="text-3xl md:text-4xl font-bold text-[#FFFFFF] mb-4">
              LAUNCH EVENT
            </h2>
            <p className="text-base md:text-lg max-w-md mb-6">
              Explore, Engage, and Discover Scientific Perspectives on Millets and
              Ancient Grains. Click below to join.
            </p>
            <a
                href="\pressrelease"
                className="learn-more-btn mt-auto"
              >
               Learn More
            </a>
         </div>
       </div>
    </div>
  </section>
  {/* FAQ SECTION */}


      <section id="home-faq-section" className="home-faq-section">
        <div className="faq-container">
          <h2 className="faq-title">Frequently Asked Questions</h2>
      
          {faqs.map((item, index) => (
            <div
              key={index}
              className={`faq-card ${activeIndex === index ? "active" : ""}`}
                 onClick={() =>
                   setActiveIndex(activeIndex === index ? null : index)
                 }      >
                         <div className="faq-question">
                           {item.question}
                 <span className="arrow"></span>
                         </div>
                 
                         <div className="faq-answer">
                   {typeof item.answer === "string" ? (
                     <p style={{ whiteSpace: "pre-line" }}>
                   {item.answer}
                 </p>
                   ) : (
                     <div className="faq-rich-content">{item.answer}</div>
                   )}
                 </div>
                       </div>
            ))}
        </div>
      </section>

    </div>
  );
};

export default Home;